import { flagPost as flagPostApi, unflagPost as unflagPostApi } from 'bundles/discussions/api/flagApi';
import {
  deletePost as deletePostApi,
  editReply as editReplyApi,
  editThread as editThreadApi,
  highlightPost as highlightPostApi,
  undoDelete as undoDeleteApi,
  unhighlightPost as unhighlightPostApi,
} from 'bundles/discussions/api/threadActionsApiUtil';

export const editThread = (
  actionContext: $TSFixMe,
  { id, questionId, question, details, reason, handleSuccess, handleFailure, dontNotify, forumType }: $TSFixMe
) => {
  editThreadApi(id, question, details, reason, dontNotify, forumType)
    .then((resp) => {
      handleSuccess(resp);
      actionContext.dispatch('EDIT_THREAD', { questionId, question, details });
    })
    .catch(handleFailure);
};

export const editReply = (actionContext: $TSFixMe, { reply, content, handleFailure, onSuccess }: $TSFixMe) => {
  editReplyApi(reply, content)
    .then((resp) => {
      actionContext.dispatch('EDIT_REPLY', { reply, content });
      actionContext.dispatch('HIDE_REPLY_EDITOR', { reply });
      onSuccess();
    })
    .catch(handleFailure);
};

export const showReplyEditor = (actionContext: $TSFixMe, { reply, reason, dontNotify }: $TSFixMe) => {
  actionContext.dispatch('SHOW_REPLY_EDITOR', { reply, reason, dontNotify });
};

export const hideReplyEditor = (actionContext: $TSFixMe, { reply }: $TSFixMe) => {
  actionContext.dispatch('HIDE_REPLY_EDITOR', { reply });
};

export const deletePost = (
  actionContext: $TSFixMe,
  { post, reason, handleSuccess, handleFailure, dontNotify }: $TSFixMe
) => {
  deletePostApi(post, reason, dontNotify)
    .then((resp) => {
      handleSuccess(resp);
      if (reason) {
        actionContext.dispatch('SOFT_DELETE_POST', { post });
      } else {
        actionContext.dispatch('DELETE_POST', { post });
      }
    })
    .catch(handleFailure);
};

export const undoDelete = (actionContext: $TSFixMe, { post, handleFailure, onSuccess }: $TSFixMe) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  undoDeleteApi(post)
    .then(() => {
      actionContext.dispatch('UNDO_DELETE', { post });
      onSuccess();
    })
    .catch(handleFailure);
};

export const flagPost = (actionContext: $TSFixMe, { post, handleSuccess, handleFailure }: $TSFixMe) => {
  flagPostApi(post)
    .then(() => {
      actionContext.dispatch('FLAG_POST', { post });
      handleSuccess();
    })
    .catch(handleFailure);
};

export const unflagPost = (actionContext: $TSFixMe, { post, handleSuccess, handleFailure }: $TSFixMe) => {
  unflagPostApi(post)
    .then((resp) => {
      actionContext.dispatch('UNFLAG_POST', { post });
      handleSuccess();
    })
    .catch(handleFailure);
};

export const highlightPost = (actionContext: $TSFixMe, { post }: $TSFixMe) => {
  highlightPostApi(post).then(() => {
    actionContext.dispatch('HIGHLIGHT', { post });
  });
};

export const unhighlightPost = (actionContext: $TSFixMe, { post }: $TSFixMe) => {
  unhighlightPostApi(post).then(() => {
    actionContext.dispatch('UNHIGHLIGHT', { post });
  });
};

export const showAdminDetails = (actionContext: $TSFixMe, { post }: $TSFixMe) => {
  actionContext.dispatch('SHOW_ADMIN_DETAILS', { post });
};

export const hideAdminDetails = (actionContext: $TSFixMe, { post }: $TSFixMe) => {
  actionContext.dispatch('HIDE_ADMIN_DETAILS', { post });
};
